import type { SiteConfig } from './site-types';

export type SiteContext = 'landing' | 'blog';

export interface NavItem {
	label: string;
	href: string;
	crossApp?: boolean;
	variant?: 'default' | 'cta';
	current?: boolean;
}

const NAV_ITEMS = [
	{ key: 'about', label: 'About' },
	{ key: 'focus', label: 'Focus' },
	{ key: 'blog', label: 'Blog', variant: 'cta' as const },
	{ key: 'verify', label: 'Verify' }
] as const;

function resolveHref(
	key: (typeof NAV_ITEMS)[number]['key'],
	site: SiteConfig,
	context: SiteContext
): string {
	switch (key) {
		case 'about':
			return '/#about';
		case 'focus':
			return context === 'landing' ? '/#focus' : `${site.urls.home}#focus`;
		case 'verify':
			return context === 'landing' ? '/verify' : `${site.urls.home}/verify`;
		case 'blog':
			return context === 'blog' ? '/' : site.urls.blog;
	}
}

function isCrossApp(key: (typeof NAV_ITEMS)[number]['key'], context: SiteContext): boolean {
	if (key === 'focus') return context === 'blog';
	if (key === 'verify') return context === 'blog';
	if (key === 'blog') return context === 'landing';
	return false;
}

export function getSiteNav(site: SiteConfig, context: SiteContext, pathname = ''): NavItem[] {
	return NAV_ITEMS.map((item) => {
		const current =
			(item.key === 'blog' && context === 'blog') ||
			(item.key === 'verify' && pathname.startsWith('/verify'));

		const variant = 'variant' in item ? item.variant : undefined;

		return {
			label: item.label,
			href: resolveHref(item.key, site, context),
			crossApp: isCrossApp(item.key, context),
			variant: current ? 'default' : variant,
			current
		};
	});
}
